import React, { useEffect } from "react";
import { TermsAndConditions } from "./TermsAndConditions";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-bg">
      <div className="terms-policy">
        <div className="container">
          <div dangerouslySetInnerHTML={{ __html: TermsAndConditions }}></div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
